import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import '../pages.scss';
import Logo from '../../components/logo.mjs';


const CreateAccountPage = () => {
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailMatch, setEmailMatch] = useState(false);
    const [emailEmpty, setEmailEmpty] = useState(false);
    const [passwordEmpty, setPasswordEmpty] = useState(false);
    const [failedCreation, setFailedCreation] = useState(undefined);
    const [fnameEmpty, setFnameEmpty] = useState(false);
    const [lnameEmpty, setLnameEmpty] = useState(false);
    const [emailConFlag, setEmailConFlag] = useState(false);
    const [conEmailMsg, setConEmailMsg] = useState('');
    const [overheadErrMsg, setOverheadErrMsg] = useState('');

    const handleSuccess = async (id) => {
        setFailedCreation(false);

        var modal = document.querySelector(".modal");
        modal.classList.remove("hidden");
        var overlay = document.querySelector(".overlay");
        overlay.classList.remove("hidden");
    }
    
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Handle empty fields
        var fname = document.getElementById("fname");
        if (firstName === '') {
            fname.style.border = 'solid 3px #C40000';
            setFnameEmpty(true);
            return;
        } 
        setFnameEmpty(false);
        fname.style.border = '';

        var lname = document.getElementById("lname");
        if (lastName === '') {
            lname.style.border = 'solid 3px #C40000';
            setLnameEmpty(true);
            return;
        }
        setLnameEmpty(false);
        lname.style.border = '';

        var emailElem = document.getElementById("email");
        if (email === '') {
            emailElem.style.border = 'solid 3px #C40000';
            setEmailEmpty(true);
            return;
        } 
        setEmailEmpty(false);
        emailElem.style.border = '';

        var emailConElem = document.getElementById("confirmEmail");
        if (confirmEmail === '') {
            emailConElem.style.border = 'solid 3px #C40000';
            setEmailConFlag(true);
            setConEmailMsg('This field is required.');
            return;
        } 
        setEmailConFlag(false);
        emailConElem.style.border = '';
        setConEmailMsg('');

        var passElem = document.getElementById("password");
        if (password === '') {
            passElem.style.border = 'solid 3px #C40000';
            setPasswordEmpty(true);
            return;
        }
        setPasswordEmpty(false);
        passElem.style.border = '';

        if (!emailMatch) {
            setConEmailMsg("Emails don't match.");
            setEmailConFlag(true);
            return;
        }

        const body = JSON.stringify({
            "data": {
                "type": "users",
                "attributes": {
                    firstName,
                    lastName,
                    email,
                    password,
                }
            }
        })

        await fetch("https://api.keygen.sh/v1/accounts/33459a88-6b71-4ab6-83db-e2ec6c252baf/users", {
            method: "POST",
            headers: {
            "Content-Type": "application/vnd.api+json",
            "Accept": "application/vnd.api+json"
            },
            body: body
        })
        .then(response => response.json())
        .then(data => {
            if (data.errors === undefined) {
                handleSuccess();
            } else {
                console.log(data.errors);

                setFailedCreation(true);
            
                if (data.errors[0].code === "EMAIL_TAKEN") {
                    setOverheadErrMsg('This account already exists. Please use the login page.');
                } else if (data.errors[0].code === "PASSWORD_TOO_SHORT") {
                    setOverheadErrMsg('The password you entered is too short. Please enter a password at least 6 characters in length.');
                } else if (data.errors.length > 0) {
                    setOverheadErrMsg('An error has occured while attempting to create your account. Please refresh and try again.');
                }
            }
        })
        .catch(error => console.log(error));
    }

    const handleShowPassword = () => {
        if (password !== "") {
            const passwordField = document.getElementById("password");
            const icon = document.getElementById("icon");

            if(passwordField.type === "password") {
            passwordField.type = "text";
            icon.innerText = "visibility_off";
            }
            else {
            passwordField.type = "password";
            icon.innerText = "visibility";
            }
        }
    }

    const handleLoginNav = () => {
        navigate("/");
    }


    return (
        <>
        <div className="overlay hidden"></div>
        <section className="modal hidden">
        <div className="forgotModal">
                <p style={{paddingBottom:'50px', width:'85%', fontSize:'16px', textAlign:'center', margin:'auto', marginTop:'85px'}}>Success! Account has been created.</p>
                <button style={{width:'70%', fontSize:'16px'}} className="btn" onClick={handleLoginNav}>Log In</button>
            </div>
        </section>

        <div className="page" id="page">
            <div style={{marginBottom:'0px', paddingBottom:'0px'}}>
                {Logo()}
            </div>
            <div style={{margin:'auto'}}>
                <p style={{margin:'auto', marginBottom:'12px'}} className="title">Welcome to the syGlass Dashboard.</p>
                <p style={{margin:'auto', marginBottom:'45px', fontSize:'18px'}}>Create an account. All fields are required.</p>
            </div>
            <i className="infoIcon" style={failedCreation ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
            <p className="errorP" style={failedCreation ? {display: 'inline-block', fontSize:'16px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>{overheadErrMsg}</p>

            <div id="loginForm">
                <p style={{fontSize:'14px', paddingTop:'0px', paddingBottom:'5px', marginBottom:'0px', textAlign:'left'}}>First name</p>
                <input style={{marginTop:'0px'}} type="text" id="fname" onChange={(e) => setFirstName(e.target.value)} required placeholder="Enter your first name"></input>
                <div style={{display:'inline-block'}}>
                    <i className="infoIcon" style={fnameEmpty ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
                    <p className="errorP" style={fnameEmpty ? {display: 'inline-block', fontSize:'15px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>This field is required.</p>
                </div>

                <p style={{fontSize:'14px', paddingTop:'0px', paddingBottom:'5px', marginBottom:'0px', textAlign:'left'}}>Last name</p>
                <input style={{marginTop:'0px'}} type="text" id="lname" onChange={(e) => setLastName(e.target.value)} required placeholder="Enter your last name"></input>
                <div style={{display:'inline-block'}}>
                    <i className="infoIcon" style={lnameEmpty ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
                    <p className="errorP" style={lnameEmpty ? {display: 'inline-block', fontSize:'15px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>This field is required.</p>
                </div>

                <p htmlFor="email" style={{fontSize:'14px', paddingTop:'0px', paddingBottom:'5px', marginBottom:'0px', textAlign:'left'}}>Email address</p>
                <div className="tooltip">
                    <input style={{marginTop:'0px'}} type="text" id="email" name="email" onChange={(e) => setEmail(e.target.value)} onPaste={(e) => e.preventDefault()} autocomplete="off" required placeholder="example@domain.com"></input>
                    <span className="tooltiptext">Use your school email. <br/>Please do not use your personal email.</span>
                    <div style={{display:'inline-block'}}>
                        <i className="infoIcon" style={emailEmpty ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
                        <p className="errorP" style={emailEmpty ? {display: 'inline-block', fontSize:'15px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>This field is required.</p>
                    </div>
                </div>

                <p htmlFor="email" style={{fontSize:'14px', paddingTop:'0px', paddingBottom:'5px', marginBottom:'0px', textAlign:'left'}}>Re-type email</p>
                <input style={{marginTop:'0px'}} type="text" id="confirmEmail" onChange={(e) =>  {setConfirmEmail(e.target.value); setEmailMatch(e.target.value === email);}} onPaste={(e) => e.preventDefault()} autocomplete="off" required placeholder="example@domain.com"></input>

                <div style={{display:'inline-block'}}>
                    <i className="infoIcon" style={emailConFlag ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
                    <p className="errorP" style={emailConFlag ? {display: 'inline-block', fontSize:'15px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>{conEmailMsg}</p>
                </div>

                <div className="passwordField" style={{marginBottom:"10px"}}>
                    <p htmlFor="password" style={{paddingBottom:'0px', marginBottom:'5px', fontSize:'14px', paddingTop:'0px', textAlign:'left'}}>Password</p>
                    <div className="tooltip">
                        <input type="password" id="password" name="password" onChange={(e) => setPassword(e.target.value)} autocomplete="off" required placeholder="Password"></input>
                        <div id="eyecon">
                            <i className="clickIcon"><span className="clickIcon" onClick={handleShowPassword} id="icon" class="material-symbols-outlined">visibility</span></i>
                        </div>
                        <span className="tooltiptext">Create a password that is<br/> at least 8 characters long.</span>
                        <div style={passwordEmpty ? {display:'inline-block', marginBottom:'0px'} : {display:'none'}}>
                            <i className="infoIcon" style={passwordEmpty ? {display: 'inline-block', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}><span className="infoIcon" class="material-symbols-outlined">info</span></i>
                            <p className="errorP" style={passwordEmpty ? {display: 'inline-block', fontSize:'15px', textAlign:'center', marginBottom:'0px', marginTop:'0px', verticalAlign:'middle'} : {display: 'none'}}>This field is required.</p>
                        </div>
                    </div>
                </div>
                <button className="btn" style={{marginTop:'20px'}} onClick={(e) => handleSubmit(e)}>Create an account</button>
            </div>
            <div style={{float:'left', marginTop:'20px', bottom:'0'}} onClick={handleLoginNav}>
                <i style={{display:'inline-block', height:'20px', marginRight:"5px", verticalAlign:'bottom', cursor:'pointer'}}><span class="material-symbols-outlined">west</span></i>
                <p style={{border:'none', background:'none', fontSize:'16px', display:'inline-block', verticalAlign:'bottom', cursor:'pointer', height:'20px', marginBottom:'0px'}}>Back to Log in</p>
            </div>
        </div>
        </>
    );
};

export default CreateAccountPage;